import axios from "axios";
import { SERVER_URL } from "../const";
import Qs from 'qs';

export const getImportDutyReportService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    let queryParams = `iec_no=${iec_no}`;

    if (filters.from_date && filters.to_date) {
      queryParams += `&from_date=${filters.from_date}&to_date=${filters.to_date}`;
    }
    if (filters.bill_no) {
      queryParams += `&bill_no=${filters.bill_no}`;
    }

    const response = await axios.get(`${SERVER_URL}/get-import-duty-report?${queryParams}`, {
      params: {
        br_code: filters.br_code && filters.br_code.length > 0
          ? filters.br_code
          : undefined
      },
      paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' }),
      headers: { 'Authorization': `Bearer ${token}` }
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching import duty report:', error);
    throw error;
  }
};

export const getExportIncentiveReportService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    let queryParams = `iec_no=${iec_no}`;

    if (filters.from_date && filters.to_date) {
      queryParams += `&from_date=${filters.from_date}&to_date=${filters.to_date}`;
    }
    if (filters.bill_no) {
      queryParams += `&bill_no=${filters.bill_no}`;
    }

    const response = await axios.get(`${SERVER_URL}/get-export-incentive-report?${queryParams}`, {
      params: {
        br_code: filters.br_code && filters.br_code.length > 0
          ? filters.br_code
          : undefined
      },
      paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' }),
      headers: { 'Authorization': `Bearer ${token}` }
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching export incentive report:', error);
    throw error;
  }
};
